import { ThemeProvider } from "styled-components";
import theme from "../utils/Theme";

const ThemeProviderContainer = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default ThemeProviderContainer;
